import React from "react";
import { ValidationStatusModel } from "../types";

import { FiCheckCircle } from "react-icons/fi";
import { CgClose } from "react-icons/cg";

interface ValidationStatusIconProps {
  validationStatus: ValidationStatusModel;
}

export default function ValidationStatusIcon(props: ValidationStatusIconProps) {
  const { validationStatus } = props;

  return validationStatus === "success" ? (
    <FiCheckCircle size={"36px"} color="#05BF8E" />
  ) : (
    <CgClose size="24px" color="#F95928" />
  );
}
